export const styles = {
  tableToolBar: {
    marginLeft: "2em",
    marginBottom: "1em",
  },
  rightButton: {
    marginLeft: "1em",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "0.5em",
    paddingTop: "1em",
  },
  table: {
    fontSize: 16,
    height: "65vh",
  },
};

export const updateStyles = {
  textFieldContainer: {
    width: "50%",
    padding: "0 1%",
    marginBottom: "1em",
  },
  textField: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  textArea: {
    width: "205%",
  },
  dialogTitle: {
    textAlign: "center",
    marginTop: "1%",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
  },
  title: {
    marginBottom: 16,
  },
};
